export enum FormCode {
  // kursna lista
  MSKURS_VAL = 'MSKURS_VAL',
  MSKURS_KURS = 'MSKURS_KURS',
  MSKURS_BNK = 'MSKURS_BNK',
  MSKURS_NBS = 'MSKURS_NBS',
  // ugovori
  MSUGO_UGO = 'MSUGO_UGO',
  MSUGO_UGOSINGLE = 'MSUGO_UGOSINGLE',
  MSUGO_UGOANEKSSINGLE = 'MSUGO_UGOANEKSSINGLE',
  MSUGO_PBUG = 'MSUGO_PBUG',
  MSUGO_PUG = 'MSUGO_PUG',
  MSUGO_PUGL = 'MSUGO_PUGL',
  MSUGO_PUGSINGLE = 'MSUGO_PUGSINGLE',
  MSUGO_TIP = 'MSUGO_TIP',
  MSUGO_TIPPODUG = 'MSUGO_TIPPODUG',
  MSUGO_NP = 'MSUGO_NP',
  MSUGO_NO = 'MSUGO_NO',
  MSUGO_NOTU = 'MSUGO_NOTU',
  MSUGO_KOR = 'MSUGO_KOR',
  MSUGO_STU = 'MSUGO_STU',
  MSUGO_VUS = 'MSUGO_VUS',
  MSUGO_VKOR = 'MSUGO_VKOR',
  MSUGO_PUGKLI = 'MSUGO_PUGKLI',
  MSUGO_MOKB = 'MSUGO_MOKB',
  MSUGO_EMIPUG = 'MSUGO_EMIPUG',
  MSUGO_PKUUB = 'MSUGO_PKUUB',
  MSUGO_PSPO = 'MSUGO_PSPO',
  MSUGO_PVSSPON = 'MSUGO_PVSSPON',
  // korisnici
  MSKOR_KOR = 'MSKOR_KOR',
  MSKOR_CKOR = 'MSKOR_CKOR',
  MSKOR_ULO = 'MSKOR_ULO',
  // cenovnici
  MSCEN_CEN = 'MSCEN_CEN',
  MSCEN_ODL = 'MSCEN_ODL',
  MSCEN_KOR = 'MSCEN_KOR',
  // Spotovi
  MSSPO_SPO = 'MSSPO_SPO',
  MSSPO_SPOID = 'MSSPO_SPOID',
  MSSPO_BRE = 'MSSPO_BRE',
  MSSPO_VRZA = 'MSSPO_VRZA',
  MSSPO_VRSP = 'MSSPO_VRSP',
  MSSPO_STSP = 'MSSPO_STSP',
  MSSPO_UPDPR = 'MSSPO_UPDPR',
  MSSPO_VST = 'MSSPO_VST',
  MSSPO_SIFRA = 'MSSPO_SIFRA',
  MSSPO_MED = 'MSSPO_MED',
  // opsti poslovi
  MSOP_CG = 'MSOP_CG',
  // Programi
  MSPRO_PRO = 'MSPRO_PRO',
  MSPRO_VRME = 'MSPRO_VRME',
  MSPRO_METRO = 'MSPRO_METRO',
  // Emisije
  MSEMI_EMI = 'MSEMI_EMI',
  MSEMI_MSEMI_UCEM = 'MSEMI_UCEM',
  MSEMI_NAEM = 'MSEMI_NAEM',
  MSEMI_VRCE = 'MSEMI_VRCE',
  // MSSPEC_EMIEMI = 'MSSPEC_EMIEMI',
  // MSSPEC_EMIDEL = 'MSSPEC_EMIDEL',
  // Klijenti
  MSKLI_KLI = 'MSKLI_KLI',
  MSKLI_FL = 'MSKLI_FL',
  MSKLI_OGS = 'MSKLI_OGS',
  MSKLI_SPL = 'MSKLI_SPL',
  MSKLI_DPL = 'MSKLI_DPL',
  MSKLI_SAP = 'MSKLI_SAP',
  MSKLI_SAP2 = 'MSKLI_SAP2',
  MSKLI_BESP_EMI = 'MSKLI_BESP_EMI',
  // Media Plan
  MSMP_MP = 'MSMP_MP',
  MSUGO_SPO = 'MSUGO_SPO',
  MSMP_REZ = 'MSMP_REZ',
  MSMP_POZ = 'MSMP_POZ',
  MSEMI_EMIDO = 'MSEMI_EMIDO',
  MSMP_RAPUB = 'MSMP_RAPUB',
  MSMP_BUR = 'MSMP_BUR',
  MSMP_RNP = 'MSMP_RNP',
  MSMP_SPCOUNT = 'MSMP_SPCOUNT',
  MSMP_SPEMICOUNT = 'MSMP_SPEMICOUNT',
  MSMP_DREZR = 'MSMP_DREZR',
  MSMP_PBRI = 'MSMP_PBRI',
  MSMP_PROSPEC = 'MSMP_PROSPEC',
  MSMP_SPOUSE = 'MSMP_SPOUSE',
  MSMP_EMIREZ = 'MSMP_EMIREZ',
  MSMP_VALREZ = 'MSMP_VALREZ',
  MSMP_GRR = 'MSMP_GRR',
  MSMP_PCSPON = 'MSMP_PCSPON',
  // Montaza
  MSMON_MON = 'MSMON_MON',
  MSMON_ZAPM = 'MSMON_ZAPM',
  MSMON_DBLK = 'MSMON_DBLK',
  MSMON_DSPI = 'MSMON_DSPI',
  MSMON_EMI = 'MSMON_EMI',
  MSMON_SMON = 'MSMON_SMON',
  MSMON_IPST = 'MSMON_IPST',
  MSMON_ZMON = 'MSMON_ZMON',
  MSMON_PDA = 'MSMON_PDA',
  MSMON_SUNB = 'MSMON_SUNB',
  MSMON_RNNB = 'MSMON_RNNB',
  MSMON_DSUM = 'MSMON_DSUM',
  MSMON_SPNM = 'MSMON_SPNM',
  MSMON_DLT = 'MSMON_DLT',
  MSMON_RSDR = 'MSMON_RSDR',
  MSMON_DGRP = 'MSMON_DGRP',
  MSMON_KLDR = 'MSMON_KLDR',
  MSMON_B2B = 'MSMON_B2B',
  MSMON_AAEL = 'MSMON_AAEL',
  MSMON_DBB = 'MSMON_DBB',
  MSMON_PLC = 'MSMON_PLC',
  MSMON_APLC = 'MSMON_APLC',
  MSMON_DBSNM = 'MSMON_DBSNM',
  MSMON_OBSUM = 'MSMON_OBSUM',
  MSMON_DBSUB = 'MSMON_DBSUB',
  MSMON_OBSUB = 'MSMON_OBSUB',
  MSMON_DBSUE = 'MSMON_DBSUE',
  MSMON_OBSUE = 'MSMON_OBSUE',
  MSMON_DBSKD = 'MSMON_DBSKD',
  MSMON_OBSKD = 'MSMON_OBSKD',
  // Uredjivanje
  MSMP_ZAPU = 'MSMP_ZAPU',
  MSMP_REER = 'MSMP_REER',
  MSMON_UER = 'MSMON_UER',
  MSMON_CER = 'MSMON_CER',
  MSMON_MER = 'MSMON_MER',
  MSMON_URE = 'MSMON_URE',
  MSMON_CREZ = 'MSMON_CREZ',
  MSEMI_EMRA = 'MSEMI_EMRA',
  MSEMI_EMRAUR = 'MSEMI_EMRAUR',
  MSMON_MREZ = 'MSMON_MREZ',
  MSMON_DREZ = 'MSMON_DREZ',
  MSMON_DBREZ = 'MSMON_DBREZ',
  // Pregled dana
  MSMON_PDCVS = 'MSMON_PDCVS',
  // Aveco Integration Servic
  MSAIS_AIS = 'MSAIS_AIS',
  MSAIS_CHECK = 'MSAIS_CHECK',
  MSREP_DPE = 'MSREP_DPE',
  MSREP_DPE_EXL = 'MSREP_DPE_EXL',
  MSREP_DPE_PDF = 'MSREP_DPE_PDF',
  MSKLI_VRSKLI = 'MSKLI_VRSKLI',
  // Video uputstva
  MSVUP_VUP = 'MSVUP_VUP',

  // Budzet
  MSBUDZET_IZV = 'MSBUDZET_IZV',
  MSBUDZET_IZV_UKUPNO = 'MSBUDZET_IZV_UKUPNO',
  MSBUDZET_IZV_UGOVOR = 'MSBUDZET_IZV_UGOVOR',
  MSBUDZET_IZV_KLIJENT = 'MSBUDZET_IZV_KLIJENT',
  MSBUDZET_IZV_PODUGOVOR = 'MSBUDZET_IZV_PODUGOVOR',
  MSBUDZET_EXCEL = 'MSBUDZET_EXCEL',
  MSBUDZET_IZVKLI = 'MSBUDZET_IZVKLI',
  MSBUDZET_IZVUGO = 'MSBUDZET_IZVUGO',
  MSBUDZET_IZVUK = 'MSBUDZET_IZVUK',

  MSVER_VER = 'MSVER_VER',

  // Izvestaji
  MSIZV_DPE = 'MSIZV_DPE',
  MSIZV_SOKOJ = 'MSIZV_SOKOJ',
  MSIZV_OFPS = 'MSIZV_OFPS',
  MSRR_GLINK = 'MSRR_GLINK',
  MSRR_REAL = 'MSRR_REAL',
  MSIZV_PGP = 'MSIZV_PGP',
  MSIZV_PPE = 'MSIZV_PPE',

  MSUGO_KALSPI = 'MSUGO_KALSPI',
  MSCPP_GVB = 'MSCPP_GVB',
}



// WEBPACK FOOTER //
// ./src/app/enums/form-code.enum.ts